import { useEffect, useState } from 'react';

export const useRerenderInterval = (intervalTime: number): void => {
  // eslint-disable-next-line
  const [time, setTime] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(Date.now());
    }, intervalTime);

    return () => {
      clearInterval(interval);
    }
  }, [intervalTime]);
}
